import { Badge } from '#/components/ui/badge';
import { OrderStatusEnum } from '#/constants/order-status';
import { Translation } from 'intl-lib';
import {
  CheckCircle,
  Hourglass,
  Loader2,
  LogOut,
  Wallet,
  Zap,
} from 'lucide-react';
import matchSwitch from 'match-switch';

interface Props {
  status: OrderStatusEnum;
}
export function OrderStatus({ status }: Props) {
  return matchSwitch(status, {
    [OrderStatusEnum.WAITING_FOR_PAYMENT]: (
      <Badge
        variant="secondary"
        className="capitalize text-xs font-normal text-yellow-800 bg-yellow-50 whitespace-nowrap"
      >
        <Wallet className="size-3.5 mr-1 shrink-0" />
        <Translation path="my_staking.order.order_status.waiting_for_payment" />
      </Badge>
    ),
    [OrderStatusEnum.PAYMENT_FAILED]: (
      <Badge
        variant="secondary"
        className="capitalize text-xs font-normal text-red-800 bg-red-50 whitespace-nowrap"
      >
        <Wallet className="size-3.5 mr-1 shrink-0" />
        <Translation path="my_staking.order.order_status.payment_failed" />
      </Badge>
    ),
    [OrderStatusEnum.PENDING]: (
      <Badge
        variant="secondary"
        className="capitalize text-xs font-normal text-blue-800 bg-blue-50 whitespace-nowrap"
      >
        <Hourglass className="size-3.5 mr-1 shrink-0" />
        <Translation path="my_staking.order.order_status.pending" />
      </Badge>
    ),
    [OrderStatusEnum.ACTIVE]: (
      <Badge
        variant="secondary"
        className="capitalize text-xs font-normal text-green-800 bg-green-50 whitespace-nowrap"
      >
        <CheckCircle className="size-3.5 mr-1 shrink-0" />
        <Translation path="my_staking.order.order_status.active" />
      </Badge>
    ),
    [OrderStatusEnum.SLASHED]: (
      <Badge
        variant="destructive"
        className="capitalize text-xs font-normal whitespace-nowrap"
      >
        <Zap className="size-3.5 mr-1" />
        <Translation path="my_staking.order.order_status.slashed" />
      </Badge>
    ),
    [OrderStatusEnum.EXITING]: (
      <Badge
        variant="secondary"
        className="capitalize text-xs font-normal whitespace-nowrap"
      >
        <Loader2 className="size-3.5 mr-1 animate-spin shrink-0" />
        <Translation path="my_staking.order.order_status.exiting" />
      </Badge>
    ),
    [OrderStatusEnum.EXIT]: (
      <Badge
        variant="secondary"
        className="capitalize text-xs text-slate-500 font-normal whitespace-nowrap"
      >
        <LogOut className="size-3.5 mr-1 shrink-0" />
        <Translation path="my_staking.order.order_status.exited" />
      </Badge>
    ),
  });
}
